// extracted by mini-css-extract-plugin
export default {"viewInRoomImage":"_585ebe7d"};